import {
	GET_LLM_PROVIDERS,
	GET_LLM_PROVIDERS_SUCCESS,
	GET_LLM_PROVIDERS_ERROR,
	GET_LLM_PROVIDERS_RESET,
} from '../actions/getLLMProvidersAction';

const initialState = {
	apiState: '',
	data: [],
	message: '',
};

const getLLMProvidersReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_LLM_PROVIDERS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_LLM_PROVIDERS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.payload.data,
				message: action.payload.message,
			};
		case GET_LLM_PROVIDERS_ERROR:
			return {
				...state,
				apiState: 'error',
				message: action.payload.message,
			};
		case GET_LLM_PROVIDERS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getLLMProvidersReducer; 